var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState, useEffect } from 'react';
import MainLayout from '../../layouts/MainLayout';
import { makeStyles, Typography, List, ListItem, ListItemText, CssBaseline, Collapse } from '@material-ui/core';
import { connect } from 'react-redux';
import { getPublisherManualPages, getPublisherManualPageById } from '../../repositories/confluence-repository';
import { useTranslation } from "react-i18next";
import WikiContent from './components/wiki-content';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import { useLocation } from "react-router-dom";
var Sidebar = function (_a) {
    var pages = _a.pages, currentPage = _a.currentPage, setCurrentPage = _a.setCurrentPage;
    var _b = useState({}), expanded = _b[0], setExpanded = _b[1];
    var classes = useStyles();
    var _c = useState([]), parentPages = _c[0], setParentPages = _c[1];
    var _d = useState({}), childPages = _d[0], setChildPages = _d[1];
    useEffect(function () {
        var parentPages = pages.filter(function (page) { return page.parentId == "98599"; });
        setParentPages(parentPages);
        var childPages = pages.reduce(function (acc, page) {
            if (page.parentId) {
                acc[page.parentId] = acc[page.parentId] || [];
                acc[page.parentId].push(page);
            }
            return acc;
        }, {});
        setChildPages(childPages);
        if (parentPages.length > 0 && currentPage == "0") {
            setCurrentPage(parentPages[0].id);
        }
    }, [pages]);
    var handleToggle = function (parentId) {
        setExpanded(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[parentId] = !prev[parentId], _a)));
        });
        setCurrentPage(parentId);
    };
    return (React.createElement("div", { className: classes.sidebar },
        React.createElement(Typography, { variant: "h5" }, "Publisher Manual"),
        React.createElement(List, null, parentPages.map(function (parent) {
            var _a;
            return (React.createElement(React.Fragment, { key: parent.id },
                React.createElement(ListItem, { button: true, className: "" + (currentPage === parent.id ? classes.active : ""), onClick: function () { return handleToggle(parent.id); } },
                    React.createElement(ListItemText, { primary: parent.title, style: { color: "#42526e" } }),
                    childPages[parent.id] ? (expanded[parent.id] ? React.createElement(ExpandLess, null) : React.createElement(ExpandMore, null)) : null),
                React.createElement(Collapse, { in: !!expanded[parent.id], timeout: "auto", unmountOnExit: true },
                    React.createElement(List, { disablePadding: true, style: { listStyle: 'disc' } }, (_a = childPages[parent.id]) === null || _a === void 0 ? void 0 : _a.map(function (child) { return (React.createElement(ListItem, { key: child.id, button: true, onClick: function () { return setCurrentPage(child.id); }, className: "" + (currentPage === child.id ? classes.active : ""), style: { paddingLeft: 32 } },
                        React.createElement(ListItemText, { primary: child.title }))); })))));
        }))));
};
var PublisherManual = function (props) {
    var classes = useStyles();
    var t = useTranslation().t;
    var location = useLocation();
    var _a = useState([]), pages = _a[0], setPages = _a[1];
    var _b = useState('0'), currentPage = _b[0], setCurrentPage = _b[1];
    var _c = useState(''), currentPageContent = _c[0], setCurrentPageContent = _c[1];
    var _d = useState(''), currentPageTitle = _d[0], setCurrentPageTitle = _d[1];
    useEffect(function () {
        getPublisherManualPages({}).then(function (res) {
            if (res.data.status == "succeeded") {
                var filteredPages = res.data.data.filter(function (page) { return page.parentId !== null; });
                // sort by position
                filteredPages.sort(function (a, b) { return a.position - b.position; });
                setPages(filteredPages);
            }
        });
        var searchParams = new URLSearchParams(location.search);
        var page = searchParams.get('page');
        if (page) {
            setCurrentPage(page);
        }
    }, []);
    var decodeHtmlEntities = function (html) {
        var txt = document.createElement("textarea");
        txt.innerHTML = html;
        return txt.value;
    };
    useEffect(function () {
        var handlePopState = function (event) {
            // detect page change
            var state = event.state;
            if (state && state.page) {
                setCurrentPage(state.page);
            }
        };
        window.addEventListener("popstate", handlePopState);
        return function () {
            window.removeEventListener("popstate", handlePopState);
        };
    }, []);
    useEffect(function () {
        if (currentPage == '0') {
            return;
        }
        window.history.pushState({ page: currentPage }, "", "#/publisher-manual?page=" + currentPage);
        var params = {
            bodyFormat: "styled_view",
        };
        getPublisherManualPageById(currentPage, params).then(function (res) {
            if (res.data.status == "succeeded") {
                var content = decodeHtmlEntities(res.data.data.body.styled_view.value);
                setCurrentPageContent(content);
                setCurrentPageTitle(res.data.data.title);
            }
        });
    }, [currentPage]);
    return (React.createElement(MainLayout, null,
        React.createElement("div", { className: classes.root },
            React.createElement(CssBaseline, null),
            React.createElement(Sidebar, { pages: pages, currentPage: currentPage, setCurrentPage: setCurrentPage }),
            React.createElement("div", { className: classes.content },
                React.createElement("div", { className: classes.contentHeader },
                    React.createElement(Typography, { variant: "h5", className: classes.contentTitle }, currentPageTitle)),
                React.createElement(WikiContent, { content: currentPageContent, onPageClick: setCurrentPage, classes: classes })))));
};
var useStyles = makeStyles(function (theme) { return ({
    root: {
        display: "flex",
        height: "100vh",
        fontFamily: "-apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif"
    },
    sidebar: {
        width: 250,
        backgroundColor: "#f5f5f5",
        marginTop: theme.spacing(2),
        paddingLeft: theme.spacing(2),
        borderRight: "1px solid #ddd",
        position: "fixed",
        height: "100vh",
        overflowY: "auto",
        color: "#42526e",
        fontSize: "14px",
        paddingBottom: theme.spacing(2),
    },
    content: {
        marginLeft: 250,
        flexGrow: 1,
        padding: theme.spacing(4),
        backgroundColor: "#FFFFFF",
    },
    contentHeader: {
        paddingBottom: theme.spacing(2),
    },
    contentInner: {
        height: '100%',
        overflow: 'none',
    },
    active: {
        backgroundColor: "#e0e0e0",
    },
    contentTitle: {
        fontWeight: "bold",
        color: "#172b4d"
    }
}); });
function mapStateToProps(state) {
    return {};
}
export default connect(mapStateToProps)(PublisherManual);
